import React, {Component} from 'react'
import fire from '../../database/firebase'
import styled from 'styled-components'
import ClipLoader from "react-spinners/ClipLoader";
import GridLoader from "react-spinners/GridLoader";
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import MediaQuery from 'react-responsive';
import SmallPhone from '../SmallPhone/SmallPhone'

const Styles2 = styled.div `

`

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage:after {
    content: "";
    display: table;
    clear: both;
}

.fullPageLeft {
    text-align: center;
    width: 30%;
    float: left;
    height: 100vh;
}

.fullPageRight {
    text-align: center;
    width: 70%;
    float: left;
    height: 100vh;
    overflow-y: scroll;
}

    //! - - FULL PAGE LEFT SIDE - - !//

.fullPageLeftInnerContainer {
    width: 90%;
    height: 97%;
    border-radius: 8px;
    margin-top: 2.5%;
    margin-left: 2.5%;
    background-color: #321d05;
    // #321d05
}

    // - FULL PAGE LEFT SIDE (INNER CONTAINER) - //

    // - - TOP COL - - //

.userInfoTop:after {
    content: "";
    display: table;
    clear: both;
}

.userInfoTopCol1 {
    text-align: left;
    width: 75%;
    float: left;
}

.userInfoTopCol2 {
    text-align: center;
    width: 25%;
    float: left;
}

        // - TOP COL (LEFT SIDE) - //

.userInfoTopCol1 h1 {
    margin-left: 3%;
    font-family: Arvo;
    color: white;
}

        // - TOP COL (RIGHT SIDE) - //

.userInfoTopCol2 button {
    margin-top: 13.5%;
    width: 47.5px;
    height: 47.5px;
    border-radius: 50%;
    border: 3px solid #0930CB;
    background-color: white;
    font-size: 20px;
    font-family: Arvo;
    color: #0930CB;
    font-weight: bold;
}

    // - CARD ROW - //

.userPointsCard {
    width: 95%;
    background-color: white;
    height: 35%;
    margin-left: 2.5%;
    border-radius: 10px;
}

.userPointsCard h4 {
    margin-bottom: 0px;
    text-align: left;
    padding: 3%;
    padding-bottom: 1.5%;
    font-family: arvo;
}

.userPointsCard h3 {
    margin-top: 0px;
    text-align: left;
    padding-left: 3%;
    padding-bottom: 2.5%;
    font-weight: bold;
    color: #0930CB;
    font-family: arvo;
    margin-bottom: 0px;
    
}

.userPointsCardInnerContainer {
    padding-bottom: 0%;
}

.userPointsCardInnerContainer:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardIcon {
    text-align: center;
    width: 25%;
    float: left;
}

.userPointsCardDetails {
    text-align: left;
    width: 75%;
    float: left;
}

.userPointsCardIcon img {
    // width: 100%;
    height: 60px;
    height: 60px;
    border: 3.5px solid #0930CB;
    padding: 7%;
    border-radius: 50%;
    margin-bottom: 0px;
}   

.userPointsCardDetails h1 {
    margin-top: 0px;
    font-family: Arvo;
    font-weight: bold;
    margin-bottom: 0px;
}

.userPointsCardDetails p {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    font-family: Arvo;
    font-weight: bold;
}

.userPointsCardFooter {
    margin-bottom: 0px;
}

.userPointsCardFooter:after {
    content: "";
    display: table;
    clear: both;
}

.userPointsCardLogo {
    text-align: left; 
    width: 50%;
    float: left;
}

.userPointsCareNumber {
    text-align: right; 
    width: 50%;
    float: left;
}

.userPointsCardLogo img {
    width: 60%;
    margin-top: 0px;
    margin-left: 2.5%;
}

.userPointsCardNumber p {
    font-size: 25px;
    margin-right: 6.5%;
    text-align: right;
    padding-bottom: 3%;
    margin-top: 1%;
    font-family: kanit;
}

    // - INVITATION CARD - //

.invitationCard {
    width: 95%;
    margin-left: 2.5%;
    background-color: white;
    border-radius: 8px;
}

.invitationCard h2 {
    font-family: Arvo;
    font-weight: bold;
    color: #0930CB;
    padding-top: 3.5%;
    margin-bottom: 0px;
}

.invitationCard p {
    padding-left: 1.5%;
    padding-right: 1.5%;
    font-family: Arvo;
    // font-weight: bold;
}

.invitationCard button {
    margin-bottom: 5%;
    width: 70%;
    padding: 3.5%;
    border: 2px solid transparent;
    border-radius: 7px;
    background-color: #0930CB;
    color: white;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
    font-size: 15.5px;
}

    // - RECENT ACTIVITY - //

.recentActivity {
    text-align: left;
    margin-left: 3.5%;
    font-weight: bold;
    font-family: arvo;
}

.recentActivity h4 {
    color: white;
    margin-bottom: 1%;
}

        // - RECENT ACTIVITY CELL - //

.recentActivityCell {
    width: 95%;
    padding-left: 2.5%;
    background-color: white;
    border-radius: 8px;
    margin-top: 3.5%;
}

.recentActivityCell:after {
    content: "";
    display: table;
    clear: both;
}

.recentActivityImg {
    text-align: center;
    width: 15%;
    float: left;
}

.recentActivityDetails {
    text-align: left;
    width: 85%;
    float: left;
}

.recentActivityImg img {
    margin-top: 8.5%;
    margin-bottom: 5%;
    height: 35px;
    width: 35px;
    border-radius: 50%;
    border: 2.5px solid #0930cb;
    padding: 11.5%;
}

.recentActivityDetails h5 {
    margin-left: 5%;
    margin-top: 4%;
    font-weight: bold;
    font-size: 13.5px;
    color: #228300;
    margin-bottom: 0px;
}

.recentActivityDetails p {
    margin-left: 4%;
    margin-top: 2%;
    font-weight: bold;
    font-size: 13.5px;
    color: #000;
}


    //! - - FULL PAGE RIGHT SIDE - - !//

    // - TOP SECTION - //

.topSectionRight {
    text-align: left;
    // margin-left: 2.5%;
}

.topSectionRight h1 {
    font-family: Arvo;
    font-size: 49px;
    margin-bottom: 1%;
}

.topSectionRightCategory {
    text-align: left;
}

.topSectionRightCategory h1 {
    font-family: Arvo;
    font-size: 49px;
    margin-bottom: 1%;
}

.topSectionRightCategory button {
    margin-top: 3.25%;
    background-color: white;
    border: 2px solid #0930CB;
    padding: 1%;
    // margin-top: 1%;
    height: 55%;
    border-radius: 7px;
    font-family: Arvo;
    font-size: 16px;
    cursor: pointer;
    width: 5%;
    text-align: center;
}

.topSectionRightCategory button:hover {
    background-color: #0930CB;
    color: white;
    font-weight: bold;
}

    // - - RIGHT PAGE LOADING - - //

.rightPageLoading {
    padding-top: 33.5%;
    padding-bottom: 12%;
    text-align: center;
}

        // - LATEST OFFER CARDS - //

.latestOfferCards:after {
    content: "";
    display: table;
    clear: both;
}

.offerCard {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35), 0 6px 20px 0 rgba(0, 0, 0, 0.35);
    text-align: center;
    width: 27.5%;
    float: left;
    border-radius: 10px;
    margin-right: 5%;
    background-color: #321d05;
}

.offerCard h2 {
    text-align: center;
    font-size: 27px;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    margin-bottom: 6%;
}

.offerCardLabel {
    width: 100%;
    background-color: #FF914D;
    padding-top: 5%;
    padding-bottom: 5%;
}

.offerCardLabel label {
    font-family: arvo;
    font-weight: bold;
    font-size: 18px;
}

.offerCardBtn button {
    margin-top: 5.5%;
    width: 45%;
    background-color: #ff;
    font-family: arvo;
    padding: 2%;
    color: #321d05;
    border: 2px solid transparent;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
}

.offerCard p {
    text-align: center;
    // margin-left: 5%;
    font-family: arvo;
    font-weight: bold;
    color: white;
    font-size: 15px;
}

.offerCard span {
    margin-right: 2%;
}

.offerCard h4 {
    margin-top: 5%;
    font-family: arvo;
    font-weight: bold;
    font-size: 20px;
    color: white;
    margin-bottom: 5.5%;
}

.offerCard img {
    width: 100%;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

        // - OTHER OPTIONS - //

.otherOptions {
    margin-top: 3%;
    width: 100%;
}

.otherOptions button {
    
}

.otherOptionsBtns button {
    width: 25%;
    padding: 2%;
    background-color: #321d05;
    color: white;
    font-family: arvo;
    font-size: 16.5px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    margin-right: 3%;
}

.otherOptionsBtns2 button {
    width: 25%;
    padding: 2%;
    background-color: #321d05;
    color: white;
    font-family: arvo;
    font-size: 16.5px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    margin-right: 3%;
    margin-top: 2.25%;
}

.selectedOptionsHeader {
    width: 92.5%;
}

.selectedOptionsHeader:after {
    content: "";
    display: table;
    clear: both;
}

.selectedOptionsTitle {
    text-align: left;
    width: 90%;
    float: left;
}

.selectedOptionsBtn {
    text-align: center;
    width: 10%;
    float: left;
}

.selectedOptionsTitle h1 {
    margin-top: 0px;
}

.selectedOptionsBtn button {
    margin-top: 8%;
    padding: 15%;
    width: 100%;
    border: 2px solid transparent;
    background-color: #321d05;
    color: white;
    border-radius: 8px;
    font-family: arvo;
    font-weight: bold;
    cursor: pointer;
}

    // - - LOADING SCREEN - - //

.loadingScreen {
    padding-top: 5.5%;
    padding-bottom: 2%;
    text-align: center;
}

.loadingScreen2 {
    padding-top: 2.5%;
    padding-bottom: 2%;
    text-align: center;
}

    // - - RENDER REWARDS TABLE - - //

.renderRewardsTable {
    // margin-left: 2.5%;
    padding-top: 2%;
    padding-bottom: 2.5%;
}

.tableContainer {

}

.tableContainer img {
    width: 25px;
    height: 25px;
    cursor: pointer;
}

.tableContainer span {
    // margin-right: 2.5%;
}

/* Style the table */

table {
    width: 92.5%;
    border-collapse: collapse;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    // font-weight: bold;
}

    /* Style the table header */

th {
  background-color: #f2f2f2;
  text-align: left;
  padding: 12px;
  color: #0930CB;
  font-family: Arvo;
}

    /* Style the table rows */

tr {
  border-bottom: 1px solid #dddddd;
}

    /* Style the table cells */

td {
  padding: 15px;
  font-family: Arvo;
  font-size: 16.5px;
}

    /* Align the content in the second-last and last columns to the right */

td:nth-last-child(3),
td:nth-last-child(2),
td:last-child,
th:nth-last-child(3),
th:nth-last-child(2),
th:last-child {
    width: 17.5%;
    text-align: right;
}

    // - - CHALLENGES CONTAINER - - //

.challengesContainer {
    margin-top: 1.5%;
    margin-bottom: 2.5%;
}

.challengesContainer:after {
    content: "";
    display: table;
    clear: both;
}

.challengeBox {
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    text-align: left;
    width: 27%;
    margin-right: 5%;
    float: left;
    margin-left: 0.5%;
}

.challengeBox:hover {
    background-color: #321d05;
    color: white;
    cursor: pointer;
}

.challengeBox h1 {
    margin-top: 2.5%;
    margin-left: 3%;
}

.challengeBox h2 {
    margin-top: 3%;
    margin-left: 4%;
    font-family: Arvo;
    font-size: 30px;
    margin-bottom: 2.5%;
}

    // - - CHALLENGES TEMPLATE - - //

.challengeTemplate {
    
}
    // - CHALLENGE TEMPLATE (TITLE) - //

.challengeTemplateHeader {
    width: 100%;
}

.challengeTemplateHeader:after {
    content: "";
    display: table;
    clear: both;
}

.challengeTemplateTitle {
    text-align: left;
    width: 82.5%;
    float: left;
}

.challengeTemplateExit {
    text-align: right;
    width: 10%;
    float: left;
}

.challengeTemplateTitle h2 {
    font-family: arvo;
    font-weight: bold;
    margin-top: 0px;
    font-size: 33px;
    padding-left: 0.5%;
}

.challengeTemplateExit button {
    width: 100%;
    background-color: white;
    color: #321d05;
    border: 2px solid #321d05;
    font-family: arvo;
    font-weight: bold;
    padding-top: 5%;
    padding-bottom: 5%;
    border-radius: 8px;
    cursor: pointer;
}

        // -  CHALLENGE CELL - //

.challengeCell {
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
    border: 2px solid #321d05;
    width: 92%;
    margin-left: 0.5%;
    border-radius: 8px;
    margin-bottom: 1.5%;
    background-color: white;
    color: #321d05;
    cursor: pointer;
}

.challengeCell:after {
    content: "";
    display: table;
    clear: both;
}

.challengeTitle {
    text-align: left;
    width: 85%;
    float: left;
}

.challengePoints {
    text-align: right;
    width: 15%;
    float: left;
}

.challengeTitle p {
    padding: 0.5%;
    font-family: arvo;
    font-weight: bold;
}

.challengePoints span {
    background-color: #321d05;
    color: #fff;
    padding: 6.5%;
    border-radius: 7px;
    border: 1.5px solid transparent;
    margin-right: 4%;
    text-align: right;
}

.challengePoints p {
    font-size: 17px;
    font-family: arvo;
    font-weight: bold;
}

    // - - SECRET MENU CONTAINER - - //

.secretMenuContainer {
    width: 92.5%;
    border: 2px solid #321d05;
    height: 500px;
    border-radius: 8px;
    margin-bottom: 2.5%;
}

.secretMenuContainer h2 {
    text-align: center;
    font-family: arvo;
    color: #321d05;
    font-size: 40px;
}


`

export default class UserLandingPg extends Component {
    constructor() {
        super()
        this.state = {
            showRightPageDisplay: true,
            showMoreOptionsTitle: true,
            showSelectedOptionTitle: false,
            showOptionsBtns: true,
            showOptionsBtns2: true,
            showOptionsLoading: false,
            showDialog: false,
            moreOptionsTitle: "More Options",
            allRewards: [],
            rewardsBtnBgColor: "white",
            rewardsBtnTxtColor: "#321d05",
            rewardsBtnBorderColor: "#321d05",
            rewardsBtnIsHovered: false,
            challengesBtnBgColor: "white",
            challengesBtnTxtColor: "#321d05",
            challengesBtnBorderColor: "#321d05",
            challengesBtnIsHovered: false,
            earningChartBtnBgColor: "white",
            earningChartBtnTxtColor: "#321d05",
            earningChartBtnBorderColor: "#321d05",
            earningChartBtnIsHovered: false,
            wishListBtnBgColor: "white",
            wishListBtnTxtColor: "#321d05",
            wishListBtnBorderColor: "#321d05",
            wishListBtnIsHovered: false,
            secretMenuBtnBgColor: "white",
            secretMenuBtnTxtColor: "#321d05",
            secretMenuBtnBorderColor: "#321d05",
            secretMenuBtnIsHovered: false
        }
    }

    //* - - - - - - - - - - - - - - - *//
    //*     SCREEN SIZE: COMPUTER     *//
    //* - - - - - - - - - - - - - - - *//

    renderDesktopView = () => {
        return (
            <Styles>
                <div className='fullPage'>
                    <div className='fullPageLeft'>
                        <div className='fullPageLeftInnerContainer'>
                            {this.renderUserInfo()}
                        </div>
                    </div>
                    <div className='fullPageRight'>
                        {this.state.showRightPageDisplay && 
                            <div className='topSectionRight'>
                                <h1>Latest Offers</h1>
                                <div className='latestOfferCards'>
                                    <div className='offerCard'>
                                        <h2><u>Coffee O'Clock</u></h2>
                                        <div className='offerCardLabel'>
                                            <label>Get 1 FREE coffee</label>
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        <p><span>☕️</span>Get a free coffee for 100 points</p>
                                        <img src='/assets/coffee-placeholder3.5.png'/> 
                                    </div>
                                    <div className='offerCard'>
                                        <h2><u>Pizza Package</u></h2>
                                        <div className='offerCardLabel'>
                                            <label>Get 25% OFF a pizza</label>
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        <p><span>🍕</span>Get a free pizza for 500 points</p>
                                        <img src='/assets/pizza-placeholder3.png'/> 
                                    </div>
                                    <div className='offerCard'>
                                        <h2><u>Burger Bundle</u></h2>
                                        <div className='offerCardLabel'>
                                            <label>Get 1 FREE extra burger</label>
                                        </div>
                                        <div className='offerCardBtn'>
                                            <button
                                            >More info</button>
                                        </div>
                                        <h4>OR</h4>
                                        <p><span>🍔</span>Get a free burger for 350 points</p>
                                        <img src='/assets/burger-placeholder.png'/> 
                                    </div>
                                </div>
                                <div className='otherOptions'>
                                    {this.state.showMoreOptionsTitle && 
                                        <h1>{this.state.moreOptionsTitle}</h1>
                                    }
                                    {this.state.showSelectedOptionTitle && 
                                        <div className='selectedOptionsHeader'>
                                            <div className='selectedOptionsTitle'>
                                                <h1>{this.state.moreOptionsTitle}</h1>
                                            </div>
                                            <div className='selectedOptionsBtn'>
                                                <button>Close</button>
                                            </div>
                                        </div>
                                    }
                                    {this.state.showOptionsBtns && 
                                        <div>
                                            <div>
                                                <div className='challengesContainer'>
                                                    <div 
                                                    className='challengeBox'
                                                    onClick={this.pointsRewardsClicked}
                                                    >
                                                        <h1>🎉</h1>
                                                        <h2>Rewards</h2>
                                                    </div>
                                                    <div 
                                                    className='challengeBox'
                                                    onClick={this.challengesClicked}
                                                    >
                                                        <h1>🎲</h1>
                                                        <h2>Challenges</h2>
                                                    </div>
                                                    <div 
                                                    className='challengeBox'
                                                    onClick={this.earningChartClicked}
                                                    >
                                                        <h1>💎</h1>
                                                        <h2>Earning Chart</h2>
                                                    </div>
                                                </div>
                                                <div className='challengesContainer'>
                                                    <div 
                                                    className='challengeBox'
                                                    onClick={this.wishListClicked}
                                                    >
                                                        <h1>💫</h1>
                                                        <h2>Wish List</h2>
                                                    </div>
                                                    <div
                                                    className='challengeBox'
                                                    onClick={this.secretMenuClicked}
                                                    >
                                                        <h1>🤫</h1>
                                                        <h2>Secret Menu</h2>
                                                    </div>
                                                    {/* <div 
                                                    className='challengeBox'
                                                    onClick={this.challengeBox6Clicked}
                                                    >
                                                        <h1>🎷</h1>
                                                        <h2>Music</h2>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.showOptionsBtns2 && 
                                        <div>
                                            <div className='otherOptionsBtns2'>
                                                {/* <button
                                                style={wishListBtnStyle}
                                                onClick={this.wishListClicked}
                                                onMouseEnter={this.wishListBtnHovered}
                                                onMouseLeave={this.wishListBtnUnhovered}
                                                >Wish List</button>
                                                <button
                                                style={secretMenuBtnStyle}
                                                onClick={this.secretMenuClicked}
                                                onMouseEnter={this.secretMenuBtnHovered}
                                                onMouseLeave={this.secretMenuUnhovered}
                                                >Secret Menu</button> */}
                                                {/* <button
                                                style={secretMenuBtnStyle}
                                                onClick={this.secretMenuClicked}
                                                onMouseEnter={this.secretMenuBtnHovered}
                                                onMouseLeave={this.secretMenuUnhovered}
                                                >Secret Menu</button> */}
                                            </div>
                                        </div>
                                    }
                                    {this.state.showOptionsLoading && 
                                        <div className='loadingScreen'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={60}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                    {this.state.showOptionsLoading2 && 
                                        <div className='loadingScreen2'>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={60}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                    {this.state.showPointsRewards && 
                                        <div className='renderRewardsTable'>
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th>Rewards</th>
                                                    <th>Quantity</th>
                                                    <th>Points</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                            </table>
                                            {this.renderRewards()}
                                        </div>
                                    }
                                    {this.state.showChallenges && 
                                        <div>
                                            <div className='challengesContainer'>
                                                <div 
                                                className='challengeBox'
                                                onClick={this.challengeBox1Clicked}
                                                >
                                                    <h1>📲</h1>
                                                    <h2>Social Media</h2>
                                                </div>
                                                <div 
                                                className='challengeBox'
                                                onClick={this.challengeBox2Clicked}
                                                >
                                                    <h1>🌳</h1>
                                                    <h2>Environment</h2>
                                                </div>
                                                <div 
                                                className='challengeBox'
                                                onClick={this.challengeBox3Clicked}
                                                >
                                                    <h1>🎉</h1>
                                                    <h2>Events</h2>
                                                </div>
                                            </div>
                                            <div className='challengesContainer'>
                                                <div 
                                                className='challengeBox'
                                                onClick={this.challengeBox4Clicked}
                                                >
                                                    <h1>🕹</h1>
                                                    <h2>Trivia</h2>
                                                </div>
                                                <div
                                                className='challengeBox'
                                                onClick={this.challengeBox5Clicked}
                                                >
                                                    <h1>🏀</h1>
                                                    <h2>Fitness</h2>
                                                </div>
                                                <div 
                                                className='challengeBox'
                                                onClick={this.challengeBox6Clicked}
                                                >
                                                    <h1>🎷</h1>
                                                    <h2>Music</h2>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.showChallengeTemplate && 
                                        <div className='challengeTemplate'>
                                            <div className='challengeTemplateHeader'>
                                                <div className='challengeTemplateTitle'>
                                                    <h2>{this.state.challengeSelectedTitle}</h2>
                                                </div>
                                                <div className='challengeTemplateExit'>
                                                    <button
                                                    >Back</button>
                                                </div>
                                            </div>
                                            <div>
                                                {this.renderSelectedChallenges()}
                                            </div>
                                        </div>
                                    }
                                    {this.state.showSecretMenu && 
                                        <div className='secretMenuContainer'>
                                            <h2><u>Welcome to the Secret Menu</u></h2>
                                            <h3></h3>
                                        </div>
                                    }
                                    <Dialog
                                    visible={this.state.showDialog}
                                    onClose={this.closeDialog}
                                    >

                                    </Dialog>
                                </div>
                            </div>
                        }
                        {this.state.showRightPageLoading && 
                            <div className='rightPageLoading'>
                                <GridLoader
                                color="#321d05"
                                loading={true}
                                // cssOverride={override}
                                size={10}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                                />
                            </div>
                        }
                        {this.state.showRewardsPage && 
                            <div className='topSectionRightCategory' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h1>Rewards</h1>
                                <button onClick={this.backToMainRightPage} style={{marginRight: "3%"}}
                                ><strong>⬅︎</strong></button>
                            </div>
                        }
                        {this.state.showChallengesPage && 
                            <div className='topSectionRightCategory' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h1>Challenges</h1>
                                <button onClick={this.backToMainRightPage} style={{marginRight: "3%"}}
                                ><strong>⬅︎</strong></button>
                            </div>
                        }
                        {this.state.showEarningChartPage && 
                            <div className='topSectionRightCategory' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h1>Earning Chart</h1>
                                <button onClick={this.backToMainRightPage} style={{marginRight: "3%"}}
                                ><strong>⬅︎</strong></button>
                            </div>
                        }
                        {this.state.showSecretMenuPage && 
                            <div className='topSectionRightCategory' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h1>Secret Menu</h1>
                                <button onClick={this.backToMainRightPage} style={{marginRight: "3%"}}
                                ><strong>⬅︎</strong></button>
                            </div>
                        }
                        {this.state.showWishListPage && 
                            <div className='topSectionRightCategory' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h1>Wish List</h1>
                                <button onClick={this.backToMainRightPage} style={{marginRight: "3%"}}
                                ><strong>⬅︎</strong></button>
                            </div>
                        }
                    </div>
                </div>
            </Styles>
        )
    }

    //* - - - - - - - - - - - - - - - *//
    //*      COMPUTER FUNCTIONS       *//
    //* - - - - - - - - - - - - - - - *//

    componentDidMount = () => {
        this.pullRewards()
    }

    pullRewards = () => {
        class Record {
            constructor(id, pointsCashValue, pointsRewardValue, rewardMenuCategory, rewardMenuItem, rewardQuantity, rewardType) {
                this.id = id
                this.pointsCashValue = pointsCashValue
                this.pointsRewardValue = pointsRewardValue
                this.rewardMenuCategory = rewardMenuCategory
                this.rewardMenuItem = rewardMenuItem
                this.rewardQuantity = rewardQuantity
                this.rewardType = rewardType
            }
            toString () {
                return this.id + ', ' +
                this.pointsCashValue + ', ' +
                this.pointsRewardValue + ', ' +
                this.rewardMenuCategory + ', ' +
                this.rewardMenuItem + ', ' +
                this.rewardQuantity + ', ' +
                this.rewardType
            }
        }
        var recordConverter = {
            toFirestore:function(record) {
                return {
                    id: record.id, 
                    pointsCashValue: record.pointsCashValue,
                    pointsRewardValue: record.pointsRewardValue, 
                    rewardMenuCategory: record.rewardMenuCategory,
                    rewardMenuItem: record.rewardMenuItem,
                    rewardQuantity: record.rewardQuantity,
                    rewardType: record.rewardType
                }
            },
            fromFirestore:function(snapshot, options) {
                const data = snapshot.data(options)
                return new Record(data.id, data.pointsCashValue, data.pointsRewardValue, data.rewardMenuCategory, 
                    data.rewardMenuItem, data.rewardQuantity, data.rewardType)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .withConverter(recordConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                allRewards: data
            })
        })
    }

    renderUserInfo = () => {
        return (
            <div>
                <div className='userInfoTop'>
                    <div className='userInfoTopCol1'>
                        <h1>Hi Norman,</h1>
                    </div>
                    <div className='userInfoTopCol2'>
                        <button
                        >NB</button>
                    </div>
                </div>
                <div className='userPointsCard'>
                    <h4>Loyalty Card</h4>
                    <h3>NORMAN BURUCHARA</h3>
                    <div className='userPointsCardInnerContainer'>
                        <div className='userPointsCardIcon'>
                            <img src='/assets/rewardCardIcon.png'/>
                        </div>
                        <div className='userPointsCardDetails'>
                            <h1>1350 Points</h1>
                            <p>550 points till your next reward</p>
                        </div>
                    </div>
                    <div className='userPointsCardFooter'>
                        <div className='userPointsCardLogo'>
                            <img src='/assets/artcaffe-logo.jpg'/>
                        </div>
                        <div className='userPointsCardNumber'>
                            <p>612 4987 12345</p>
                        </div>
                    </div>
                </div>
                <div className='invitationCard'>
                    <h2>Start earning points</h2>
                    <p>To start earning points, share your referral code. Earn 10 points every time someone signs up with your code.</p>
                    <button
                    >Share Code</button>
                </div>
                <div className='recentActivity'>
                    <h4>Recent Activity</h4>
                    <div className='recentActivityCell'>
                        <div className='recentActivityImg'>
                            <img src='/assets/recent-activity6.5.gif'/>
                        </div>
                        <div className='recentActivityDetails'>
                            <h5>+ Cappuccino (KES 270) </h5>
                            <p>📍 Artcaffe, The Hub</p>
                        </div>
                    </div>
                    <div className='recentActivityCell'>
                        <div className='recentActivityImg'>
                            <img src='/assets/recent-activity6.5.gif'/>
                        </div>
                        <div className='recentActivityDetails'>
                            <h5>+ Art Rose Hibiscus Iced Tea (KES 390) </h5>
                            <p>📍 Artcaffe, The Hub</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    pointsRewardsClicked = () => {
        this.setState({
            showRightPageDisplay: false,
            showRightPageLoading: true,
            rewardsBtnBgColor: "white",
            rewardsBtnTxtColor: "#321d05",
            rewardsBtnBorderColor: "#321d05"
        }, () => {
            setTimeout(() => {
                this.setState({
                   showRightPageLoading: false,
                   showRewardsPage: true
                })
            }, 2500)
        })
    }

    challengesClicked = () => {
        this.setState({
            showRightPageDisplay: false,
            showRightPageLoading: true,
            challengesBtnBgColor: "white",
            challengesBtnTxtColor: "#321d05",
            challengesBtnBorderColor: "#321d05"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRightPageLoading: false,
                    showChallengesPage: true
                })
            }, 2500)
        })
    }

    earningChartClicked = () => {
        this.setState({
            showRightPageDisplay: false,
            showRightPageLoading: true,
            earningChartBtnBgColor: "white",
            earningChartBtnTxtColor: "#321d05",
            earningChartBtnBorderColor: "#321d05"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRightPageLoading: false,
                    showEarningChartPage: true
                })
            }, 2500)
        })
    }

    wishListClicked = () => {
        this.setState({
            showRightPageDisplay: false,
            showRightPageLoading: true,
            wishListBtnBgColor: "white",
            wishListBtnTxtColor: "#321d05",
            wishListBtnBorderColor: "#321d05"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRightPageLoading: false,
                    showWishListPage: true
                })
            }, 2500)
        })
    }

    secretMenuClicked = () => {
        this.setState({
            showRightPageDisplay: false,
            showRightPageLoading: true,
            wishListBtnBgColor: "white",
            wishListBtnTxtColor: "#321d05",
            wishListBtnBorderColor: "#321d05"
        }, () => {
            setTimeout(() => {
                this.setState({
                   showRightPageLoading: false,
                   showSecretMenuPage: true
                })
            }, 2500)
        })
    }

    backToMainRightPage = () => {
        this.setState({
            showRewardsPage: false,
            showWishListPage: false,
            showEarningChartPage: false,
            showChallengesPage: false,
            showSecretMenuPage: false,
            showRightPageLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                   showRightPageLoading: false,
                   showRightPageDisplay: true
                })
            }, 2500)
        })
    }

    renderRewards = () => {
        if (!this.state.allRewards.length == 0) {
            return this.state.allRewards.map(records => {
                var {pointsRewardValue, rewardMenuCategory, rewardMenuItem, rewardQuantity, rewardType} = records

                if (rewardType == "percentage-off") {
                    rewardType = "% Off"
                } else if (rewardType == "free-item") {
                    rewardType = "Free Item"
                } else {
                    rewardType = "Amount Off"
                }

                // if ()
                let availableTxt = "Redeem"
                
                let emojiSpanStyle = {
                    marginRight: "2.5%"
                }

                let statusSpanStyle = {
                    backgroundColor: "#72F043",
                    padding: "4.5%",
                    paddingLeft: "6%",
                    paddingRight: "6%",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15)",
                    fontWeight: "normal",
                    fontSize: "14.5px"
                }

                return (
                    <div className='tableContainer'>
                        <table>
                            <tbody>
                            <tr>
                                <td><span style={emojiSpanStyle}>🎉</span>{rewardMenuItem}</td>
                                <td>{rewardQuantity}</td>
                                <td>{pointsRewardValue} points</td>
                                {/* <td>{pointsCashValue}</td> */}
                                <td><span style={statusSpanStyle}>{availableTxt}</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                )
            })
        }
    }

    rewardsBtnHovered = () => {
        this.setState({ 
            rewardsBtnBgColor: "#321d05",
            rewardsBtnTxtColor: "white",
            rewardsBtnBorderColor: "transparent"
         });
    };
    
    rewardsBtnUnhovered = () => {
        this.setState({ 
            rewardsBtnBgColor: "white",
            rewardsBtnTxtColor: "#321d05",
            rewardsBtnBorderColor: "#321d05"
         });
    };

    challengesBtnHovered = () => {
        this.setState({ 
            challengesBtnBgColor: "#321d05",
            challengesBtnTxtColor: "white",
            challengesBtnBorderColor: "transparent"
         });
    }

    challengesBtnUnhovered = () => {
        this.setState({ 
            challengesBtnBgColor: "white",
            challengesBtnTxtColor: "#321d05",
            challengesBtnBorderColor: "#321d05"
         });
    }

    earningChartBtnHovered = () => {
        this.setState({
            earningChartBtnBgColor: "#321d05",
            earningChartBtnTxtColor: "white",
            earningChartBtnBorderColor: "transparent"
        })
    }

    earningChartBtnUnhovered = () => {
        this.setState({
            earningChartBtnBgColor: "white",
            earningChartBtnTxtColor: "#321d05",
            earningChartBtnBorderColor: "#321d05"
        })
    }

    secretMenuBtnHovered = () => {
        this.setState({ 
            secretMenuBtnBgColor: "#321d05",
            secretMenuBtnTxtColor: "white",
            secretMenuBtnBorderColor: "transparent"
         });
    }

    secretMenuUnhovered = () => {
        this.setState({ 
            secretMenuBtnBgColor: "white",
            secretMenuBtnTxtColor: "#321d05",
            secretMenuBtnBorderColor: "#321d05"
         });
    }

    wishListBtnHovered = () => {
        this.setState({
            wishListBtnBgColor: "#321d05",
            wishListBtnTxtColor: "white",
            wishListBtnBorderColor: "transparent"
        })
    }

    wishListBtnUnhovered = () => {
        this.setState({
            wishListBtnBgColor: "white",
            wishListBtnTxtColor: "#321d05",
            wishListBtnBorderColor: "#321d05"
        })
    }

    challengeBox1Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Social Media 📱"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true
                })
            }, 2500)
        })
    }

    challengeBox2Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Environment 🌳"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true,
                })
            }, 2500)
        })
    }

    challengeBox3Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Events 📆"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true,
                })
            }, 2500)
        })
    }

    challengeBox4Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Trivia 🕹"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true,
                })
            }, 2500)
        })
    }
    
    challengeBox5Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Fitness 🏀"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true,
                })
            }, 2500)
        })
    }

    challengeBox6Clicked = () => {
        this.setState({
            showChallenges: false,
            showOptionsLoading2: true,
            challengeSelectedTitle: "Music 🎷"
        }, () => {
            setTimeout(() => {
                this.setState({
                    showOptionsLoading2: false,
                    showChallengeTemplate: true,
                })
            }, 2500)
        })
    }

    renderSelectedChallenges = () => {
        return(
            <div>
                <div className='challengeCell'>
                    <div className='challengeTitle' onClick={this.openDialog}>
                        <p>Record a TikTok of you telling us your favorite drink & why you love it so much. Then tell us your fav a a memory from childhood. Upload it to Google drive.</p>
                    </div>
                    <div className='challengePoints'>
                        <p><span>1000 points</span></p>
                    </div>
                </div>
                <div className='challengeCell'>
                    <div className='challengeTitle' onClick={this.openDialog}>
                        <p>Post a story on Instagram celebrating #ArtCafeDay</p>
                    </div>
                    <div className='challengePoints'>
                        <p><span>100 points</span></p>
                    </div>
                </div>
                <div className='challengeCell'>
                    <div className='challengeTitle' onClick={this.openDialog}>
                        <p>Change your WhatsApp status </p>
                    </div>
                    <div className='challengePoints'>
                        <p><span>1 point</span></p>
                    </div>
                </div>
            </div>
            
        )
    }

    openDialog = () => {
        this.setState({
            showDialog: true
        })
    }

    closeDialog = () => {
        this.setState({
            showDialog: false
        })
    }

    //* - - - - - - - - - - - - - - - *//
    //?    SCREEN SIZE: SMALL PHONE   ?//
    //* - - - - - - - - - - - - - - - *//

    renderSmallPhoneView = () => {
        return (
            <SmallPhone/>
        )
    }

    //* - - - - - - - - - - - - - - - *//
    //?  SCREEN SIZE: STANDARD PHONE  ?//
    //* - - - - - - - - - - - - - - - *//

    renderStandardPhoneView = () => {
        return(
            <Styles2>

            </Styles2>
        )
    }

    //* - - - - - - - - - - - - - - - *//
    //?     SCREEN SIZE: PHABLET      ?//
    //* - - - - - - - - - - - - - - - *//

    renderPhabletView = () => {
        return( 
            <Styles2>

            </Styles2>
        )
    }

    //* - - - - - - - - - - - - - - - *//
    //?      SCREEN SIZE: TABLET      ?//
    //* - - - - - - - - - - - - - - - *//

    renderTabletView = () => {
        return (
            <Styles2>

            </Styles2>
        )
    }


    render () {
        let earningChartStyle = {
            backgroundColor: this.state.earningChartBtnBgColor,
            color: this.state.earningChartBtnTxtColor,
            border: `2px solid ${this.state.earningChartBtnBorderColor}`
        }

        let rewardsBtnStyle = {
            backgroundColor: this.state.rewardsBtnBgColor,
            color: this.state.rewardsBtnTxtColor,
            border: `2.5px solid ${this.state.rewardsBtnBorderColor}`
        }

        let challengesBtnStyle = { 
            backgroundColor: this.state.challengesBtnBgColor,
            color: this.state.challengesBtnTxtColor,
            border: `2.5px solid ${this.state.challengesBtnBorderColor}`
        }

        let secretMenuBtnStyle = {
            backgroundColor: this.state.secretMenuBtnBgColor,
            color: this.state.secretMenuBtnTxtColor,
            border: `2.5px solid ${this.state.secretMenuBtnBorderColor}`
        }

        let wishListBtnStyle = {
            backgroundColor: this.state.wishListBtnBgColor,
            color: this.state.wishListBtnTxtColor,
            border: `2px solid ${this.state.wishListBtnBorderColor}`
        }

        const computerMediaQuery = `(min-width: 1025px)`
        const tabletMediaQuery = `(min-width: 769px) and (max-width: 1024px)`; 
        const phabletMediaQuery = `(min-width: 415px) and (max-width: 768px)`
        // const standardPhoneQuery = `(min-width: 376px) and (max-width: 414px)`
        const smallPhoneQuery = `(min-width: 320px) and (max-width: 414px)`

        return (
            <Styles2>
                {/*  - - RENDER LAPTOP/DESKTOP VIEW - - */}

                <MediaQuery query={computerMediaQuery}>
                    {this.renderDesktopView()}
                </MediaQuery>


                {/*  - - RENDER TABLET VIEW - - */}
                
                <MediaQuery query={tabletMediaQuery}>
                    {this.renderTabletView()}
                </MediaQuery>


                {/*  - - RENDER PHABLET VIEW - - */}

                <MediaQuery query={phabletMediaQuery}>
                    {this.renderPhabletView()}
                </MediaQuery>


                {/*  - - RENDER STANDARD PHONE VIEW - - */}

                {/* <MediaQuery query={standardPhoneQuery}>
                    {this.renderStandardPhoneView()}
                </MediaQuery> */}


                {/*  - - RENDER SMALL PHONE VIEW - - */}

                <MediaQuery query={smallPhoneQuery}>
                    {this.renderSmallPhoneView()}
                </MediaQuery>
            </Styles2>
        )
    }
}